class LazyScriptLoader {
  constructor() {
    this.scripts = [];
    this.selector = "script[data-loading=\"lazy\"][data-src]";
    this.interactionEvents = ["mouseover","keydown","touchmove","touchstart","click"];
    // Fallback for idle visitors only; any interaction loads immediately, so 10s keeps these off the initial main thread
    this.loadAfterMsIfNoInteraction = 10000;
    this.loadTimer = null;
    // Store bound handler so removeEventListener actually removes it
    this.boundStart = this.startLoadingScripts.bind(this);
  }


  init() {
    // find all scripts
    this.scripts = document.querySelectorAll(this.selector);

    // if there are no scripts, return
    if (this.scripts.length === 0) return;

    // load scripts on user interaction
    this.interactionEvents.forEach((event) => {
      document.addEventListener(event, this.boundStart, { passive: true });
    });

    // load scripts after a timeout if no user interaction
    this.loadTimer = setTimeout(this.boundStart, this.loadAfterMsIfNoInteraction);
  }

  startLoadingScripts() {
    clearTimeout(this.loadTimer);

    this.loadScripts();
    this.interactionEvents.forEach((event) => {
      document.removeEventListener(event, this.boundStart);
    })
  }

  loadScripts() {
    this.scripts.forEach((script) => {
      if (script.dataset.loading === "loaded") return;
      this.loadScript(script);
    });
  }

  loadScript(script) {
    script.dataset.loading = "loaded";
    script.src = script.dataset.src;
    script.removeAttribute("data-src");
  }
}

const loader = new LazyScriptLoader();
// Use addEventListener so we never clobber other window.onload handlers from apps
window.addEventListener('load', loader.init.bind(loader));